<template>
	<v-card class="mt-8 pa-4">
        <div class="action-bar">
            <div class="headline page-title">{{ pageTitle }}</div>

            <div class="actions">
                <!-- <v-text-field class="search-field mx-4" :label="'Search ' + pageTitle" hide-details></v-text-field> -->

                <v-btn v-if="addNew" class="add-new" @click="addNew()">
                    <v-icon>mdi-plus</v-icon>
                    <span>New</span>
                </v-btn>
            </div>
        </div>
    </v-card>
	
</template>

<script>
    import './style.scss';

	export default {
		name: 'ActionBar',
        components: {  },
        props: ['pageTitle', 'addNew'],
		data: () => {
            return {}
        },
	}
</script>

<style>

</style>
